import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import Login from '../views/auth/Login'

import Dashboard from '../views/dashboard/Dashboard'
import DashboardClient from "../views/client/DashboardClient";

import PlanningIndex from '../views/planning/PlanningIndex'

import UserIndex from '../views/user/UserIndex'
import UserShow from '../views/user/UserShow'
import UserCreate from '../views/user/UserCreate'
import UserEdit from '../views/user/UserEdit'
import ProfileShow from "../views/user/ProfileShow";
import ProfileEdit from "../views/user/ProfileEdit";

import UrbanStudyIndex from '../views/urbanStudy/UrbanStudyIndex'
import UrbanStudyShow from '../views/urbanStudy/UrbanStudyShow'
import UrbanStudyCreate from '../views/urbanStudy/UrbanStudyCreate'
import UrbanStudyEdit from '../views/urbanStudy/UrbanStudyEdit'
import ContactCreate from "../views/contact/ContactCreate";
import ContactEdit from "../views/contact/ContactEdit";
import ContactIndex from "../views/contact/ContactIndex";
import ContactShow from "../views/contact/ContactShow";

import SimulationIndex from '../views/simulation/SimulationIndex'
import SimulationCreateEdit from '../views/simulation/SimulationCreateEdit'
import SimulationShow from '../views/simulation/SimulationShow'

import OperationIndex from '../views/operation/OperationIndex'
import OperationShow from "../views/operation/OperationShow"
import OperationCreate from '../views/operation/OperationCreate'
import OperationEdit from '../views/operation/OperationEdit'
import OperationLotsEdit from "../views/operation/components/OperationLotsEdit";
import OperationBilanCreateEdit from "../views/operationBilan/OperationBilanCreateEdit";
import OperationTaskShow from "../views/operationTask/OperationTaskShow";
import OperationTaskCreateEdit from "../views/operationTask/OperationTaskCreateEdit";
import OperationDocumentEdit from "../views/operationDocument/OperationDocumentEdit"
import OperationDocumentCreate from "../views/operationDocument/OperationDocumentCreate.vue";
import OperationDossierCreateEdit from "../views/operationDossier/OperationDossierCreateEdit"

import CommercialisationLotsIndex from "../views/commercialisation/CommercialisationLotsIndex.vue";
import CommercialisationLotsShow from "../views/commercialisation/CommercialisationLotsShow.vue";

import ProfessionalChargesCreateEdit from "../views/professionalCharges/ProfessionalChargesCreateEdit";
import ProfessionalChargesIndex from "../views/professionalCharges/ProfessionalChargesIndex";
import InvestorContratCreateEdit from "../views/investor/investorContrat/InvestorContratCreateEdit";
import InvestorContratIndex from "../views/investor/investorContrat/InvestorContratIndex";
import InvestorRefundCreateEdit from "../views/investor/investorRefund/InvestorRefundCreateEdit";
import InvestorInterestCreateEdit from "../views/investor/investorInterest/InvestorInterestCreateEdit";
import InvestorInterestIndex from "../views/investor/investorInterest/InvestorInterestIndex";
import InvestorShow from "../views/investor/InvestorShow";

import TreasuryIndex from '../views/treasury/TreasuryIndex'
import TreasuryShow from "../views/treasury/TreasuryShow";
import TreasuryCreateEdit from '../views/treasury/TreasuryCreateEdit'
import TreasuryHistory from "../views/treasury/TreasuryHistory.vue";
import OperationEvenementCreateEdit from "../views/operationPlanning/OperationEvenementCreateEdit"

import SocietyBalanceSheetIndex from "../views/societyBalanceSheet/SocietyBalanceSheetIndex";

import OperationEmpruntCreateEdit from "../views/operationEmprunt/OperationEmpruntCreateEdit"
import OperationShowDocuments from "../views/operation/OperationShowTabs/OperationShowDocuments.vue";
import OperationShowTasks from "../views/operation/OperationShowTabs/OperationShowTasks.vue";
import OperationShowPlanning from "../views/operation/OperationShowTabs/OperationShowPlanning.vue";
import OperationShowAnalyse from "../views/operation/OperationShowTabs/OperationShowAnalyse.vue";
import OperationShowDossier from "../views/operation/OperationShowTabs/OperationShowDossier.vue";
import OperationShowEmprunt from "../views/operation/OperationShowTabs/OperationShowEmprunt.vue";
import OperationShowInvestor from "../views/operation/OperationShowTabs/OperationShowInvestor.vue";
import OperationBilanChargeFonciere
  from "../views/operationBilan/bilanCreateEditSteps/OperationBilanChargeFonciere.vue";
import OperationBilanConstruction from "../views/operationBilan/bilanCreateEditSteps/OperationBilanConstruction.vue";
import OperationBilanHonoraires from "../views/operationBilan/bilanCreateEditSteps/OperationBilanHonoraires.vue";
import OperationBilanInsurances from "../views/operationBilan/bilanCreateEditSteps/OperationBilanInsurances.vue";
import OperationBilanFraisFinanciers
  from "../views/operationBilan/bilanCreateEditSteps/OperationBilanFraisFinanciers.vue";
import OperationBilanChargeFonciereEdit
  from "../views/operationBilan/bilanEditSteps/OperationBilanChargeFonciereEdit.vue";
import OperationBilanConstructionEdit from "../views/operationBilan/bilanEditSteps/OperationBilanConstructionEdit.vue";
import OperationBilanHonorairesEdit from "../views/operationBilan/bilanEditSteps/OperationBilanHonorairesEdit.vue";
import OperationBilanFraisFinanciersEdit
  from "../views/operationBilan/bilanEditSteps/OperationBilanFraisFinanciersEdit.vue";
import OperationBilanInsurancesEdit from "../views/operationBilan/bilanEditSteps/OperationBilanInsurancesEdit.vue";
import OperationDevisShow from "../views/operationDevis/OperationDevisShow.vue";
import OperationDevisEdit from "../views/operationDevis/OperationDevisEdit.vue";
import OperationShowAllLinks from "../views/operationDocument/OperationShowAllLinks.vue";
import VenteLotIndex from "../views/venteLot/VenteLotIndex.vue";
import VenteLotCreateEdit from "../views/venteLot/VenteLotCreateEdit.vue";
import VenteLotShow from "../views/venteLot/VenteLotShow.vue";
import DashboardAgentImmo from "../views/dashboard/DashboardAgentImmo.vue";
import VenteLotShowAgent from "../views/venteLot/VenteLotShowAgent.vue";

import OperationDevisIndex from "../views/operationDevis/OperationDevisIndex.vue";
import OperationFactureIndex from "../views/OperationFacture/OperationFactureIndex";
import OperationFactureShow from "../views/OperationFacture/OperationFactureShow";
import OperationDevisFacturesIndex from "../views/operationDevisFactures/OperationDevisFacturesIndex.vue";
import OperationDevisFactureShow from "../views/operationDevisFactures/OperationDevisFactureShow.vue";

import OperationFactureCreateEdit from "../views/OperationFacture/OperationFactureCreateEdit";

import TutorialIndex from "../views/tutorial/TutorialIndex";
import TutorialCreateEdit from "../views/tutorial/TutorialCreateEdit";
import TutorialShow from "../views/tutorial/TutorialShow";
import TutorialUpdateOrdre from "../views/tutorial/TutorialUpdateOrder";
import ScheduleShow from "../views/operation/OperationSchedule/ScheduleShow";
import ScheduleEdit from "../views/operation/OperationSchedule/ScheduleEdit";
import ScheduleGlobalEdit from "../views/operation/OperationSchedule/ScheduleGlobalEdit";

import PartenaireIndex from "../views/partenaire/PartenaireIndex.vue";
import PartenaireCreateEdit from "../views/partenaire/PartenaireCreateEdit.vue";
import PartenaireShow from "../views/partenaire/PartenaireShow.vue";
import DashboardAdmin from "../views/dashboard/DashboardAdmin.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login/:component?/:token?/:userId?',
    name: 'Login',
    component: Login,
    meta: {
      guest: true
    }
  },
  {
    path: '/dashboardAgentImmo',
    name: 'DashboardAgentImmo',
    component: DashboardAgentImmo,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_AGENT_IMMO']
    }
  },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/dashboardAdmin/index',
    name: 'DashboardAdmin',
    component: DashboardAdmin,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/profile',
    name: 'ProfileShow',
    component: ProfileShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS', 'ROLE_AGENT_IMMO']
    }
  },
  {
    path: '/profile/edit',
    name: 'ProfileEdit',
    component: ProfileEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS', 'ROLE_AGENT_IMMO']
    }
  },
  {
    path: '/user/index',
    name: 'UserIndex',
    component: UserIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_ESTATE_AGENT']
    }
  },
  {
    path: '/user/show/:userId',
    name: 'UserShow',
    component: UserShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_ESTATE_AGENT']
    }
  },
  {
    path: '/user/create',
    name: 'UserCreate',
    component: UserCreate,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_ESTATE_AGENT']
    }
  },
  {
    path: '/user/edit/:userId',
    name: 'UserEdit',
    component: UserEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_ESTATE_AGENT']
    }
  },
  {
    path: '/urbanStudy/index',
    name: 'UrbanStudyIndex',
    component: UrbanStudyIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/urbanStudy/show/:urbanStudyId',
    name: 'UrbanStudyShow',
    component: UrbanStudyShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/urbanStudy/create',
    name: 'UrbanStudyCreate',
    component: UrbanStudyCreate,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/urbanStudy/edit/:urbanStudyId',
    name: 'UrbanStudyEdit',
    component: UrbanStudyEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/simulation/index',
    name: 'SimulationIndex',
    component: SimulationIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/simulation/createEdit/:simulationId?',
    name: 'SimulationCreateEdit',
    component: SimulationCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/simulation/show/:simulationId',
    name: 'SimulationShow',
    component: SimulationShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/index',
    name: 'OperationIndex',
    component: OperationIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/show/:operationId',
    name: 'OperationShow',
    component: OperationShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/create',
    name: 'OperationCreate',
    component: OperationCreate,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/edit/:operationId',
    name: 'OperationEdit',
    component: OperationEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/documents/:operationId',
    name: 'OperationShowDocuments',
    component: OperationShowDocuments,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/allLinks/:operationId',
    name: 'OperationShowAllLinks',
    component: OperationShowAllLinks,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/planning/:operationId',
    name: 'OperationShowPlanning',
    component: OperationShowPlanning,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/schedule/show/:operationId',
    name: 'ScheduleShow',
    component: ScheduleShow,
    props: (route) => ({
      operationId: route.params.operationId,
      operationType: route.params.operationType
    }),
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/schedule/edit/:operationId',
    name: 'ScheduleEdit',
    component: ScheduleEdit,
    props: (route) => ({
      operationId: route.params.operationId,
      operationType: route.params.operationType || null
    }),
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/schedule/globalEdit/:operationId',
    name: 'ScheduleGlobalEdit',
    component: ScheduleGlobalEdit,
    props: (route) => ({
      operationId: route.params.operationId,
      operationType: route.params.operationType || null
    }),
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/tasks/:operationId',
    name: 'OperationShowTasks',
    component: OperationShowTasks,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/analyse/:operationId',
    name: 'OperationShowAnalyse',
    component: OperationShowAnalyse,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/dossier/:operationId',
    name: 'OperationShowDossier',
    component: OperationShowDossier,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/emprunt/:operationId',
    name: 'OperationShowEmprunt',
    component: OperationShowEmprunt,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/investor/:operationId',
    name: 'OperationShowInvestor',
    component: OperationShowInvestor,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/operationLotsEdit/:operationId',
    name: 'OperationLotsEdit',
    component: OperationLotsEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/createBilan/:operationId',
    name: 'OperationBilanCreateEdit',
    component: OperationBilanCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/:operationId?/createDossier/:dossierId?',
    name: 'OperationDossierCreateEdit',
    component: OperationDossierCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/task/show/:operationTaskId',
    name: 'OperationTaskShow',
    component: OperationTaskShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/dashboard/task/show/:operationTaskId',
    name: 'OperationTaskShowFromDashboard',
    component: OperationTaskShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/task/createEdit/:operationTaskId?',
    name: 'OperationTaskCreateEdit',
    component: OperationTaskCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/dashboard/task/createEdit/:operationTaskId?',
    name: 'OperationTaskCreateEditFromDashboard',
    component: OperationTaskCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/document/edit/:operationDocumentId',
    name: 'OperationDocumentEdit',
    component: OperationDocumentEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/document/createEdit/:operationDocumentId?',
    name: 'OperationDocumentCreate',
    component: OperationDocumentCreate,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/createEditEvenement/:operationId?',
    name: 'OperationEvenementCreateEdit',
    component: OperationEvenementCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/commercialisationlots/index',
    name: 'CommercialisationLotsIndex',
    component: CommercialisationLotsIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/commercialisationlots/show/:operationId',
    name: 'CommercialisationLotsShow',
    component: CommercialisationLotsShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  // {
  //   path: '/planning/index',
  //   name: 'PlanningIndex',
  //   component: PlanningIndex,
  //   meta: {
  //     requiresAuth: true,
  //     roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
  //   }
  // },
  {
    path: '/treasury/index',
    name: 'TreasuryIndex',
    component: TreasuryIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/treasury/:operationId',
    name: 'TreasuryShow',
    component: TreasuryShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  // {
  //   path: '/operation/treasury/history/:operationId',
  //   name: 'TreasuryHistory',
  //   component: TreasuryHistory,
  //   meta: {
  //     requiresAuth: true,
  //     roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
  //   }
  // },
  // {
  //   path: '/operation/treasury/createEdit/:operationId?',
  //   name: 'TreasuryCreateEdit',
  //   component: TreasuryCreateEdit,
  //   meta: {
  //     requiresAuth: true,
  //     roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
  //   }
  // },
  {
    path: '/treasury/createEdit/:treasuryId?',
    name: 'TreasuryCreateEdit',
    component: TreasuryCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/treasury/history',
    name: 'TreasuryHistory',
    component: TreasuryHistory,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/investor/contrat/index',
    name: 'InvestorContratIndex',
    component: InvestorContratIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/investor/contrat/createEdit/:investorContratId?',
    name: 'InvestorContratCreateEdit',
    component: InvestorContratCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/investor/refund/createEdit/:investorRefundId?',
    name: 'InvestorRefundCreateEdit',
    component: InvestorRefundCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/investor/interest/index',
    name: 'InvestorInterestIndex',
    component: InvestorInterestIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/investor/interest/createEdit/:investorInterestId?',
    name: 'InvestorInterestCreateEdit',
    component: InvestorInterestCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/investor/show/:investorContratId?',
    name: 'InvestorShow',
    component: InvestorShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/societyBalanceSheet/index',
    name: 'SocietyBalanceSheetIndex',
    component: SocietyBalanceSheetIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/professionalCharges/index',
    name: 'ProfessionalChargesIndex',
    component: ProfessionalChargesIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/professionalCharges/createEdit/:chargeId?',
    name: 'ProfessionalChargesCreateEdit',
    component: ProfessionalChargesCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/contact/index',
    name: 'ContactIndex',
    component: ContactIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/contact/show/:contactId',
    name: 'ContactShow',
    component: ContactShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/contact/create',
    name: 'ContactCreate',
    component: ContactCreate,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/contact/edit/:contactId',
    name: 'ContactEdit',
    component: ContactEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/:operationId/empruntCreateEdit/:empruntId?',
    name: 'OperationEmpruntCreateEdit',
    component: OperationEmpruntCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/chargeFonciere/:operationId?&:operationBilanId?&:simulationId?',
    name: 'OperationBilanChargeFonciere',
    component: OperationBilanChargeFonciere,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/construction/:operationId?&:operationBilanId?&:simulationId?',
    name: 'OperationBilanConstruction',
    component: OperationBilanConstruction,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/honoraires/:operationId?&:operationBilanId?&:simulationId?',
    name: 'OperationBilanHonoraires',
    component: OperationBilanHonoraires,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/insurances/:operationId?&:operationBilanId?&:simulationId?',
    name: 'OperationBilanInsurances',
    component: OperationBilanInsurances,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/frais_financiers/:operationId?&:operationBilanId?&:simulationId?',
    name: 'OperationBilanFraisFinanciers',
    component: OperationBilanFraisFinanciers,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/chargeFonciereEdit/:operationId?&:operationBilanId?&:simulationId?',
    name: 'OperationBilanChargeFonciereEdit',
    component: OperationBilanChargeFonciereEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/constructionEdit/:operationId?&:operationBilanId?&:simulationId?',
    name: 'OperationBilanConstructionEdit',
    component: OperationBilanConstructionEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/honorairesEdit/:operationId?&:operationBilanId?&:simulationId?',
    name: 'OperationBilanHonorairesEdit',
    component: OperationBilanHonorairesEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/frais_financiersEdit/:operationId?&:operationBilanId?&:simulationId?',
    name: 'OperationBilanFraisFinanciersEdit',
    component: OperationBilanFraisFinanciersEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/insurancesEdit/:operationId?&:operationBilanId?&:simulationId?',
    name: 'OperationBilanInsurancesEdit',
    component: OperationBilanInsurancesEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/devis/index/:operationId',
    name: 'OperationDevisIndex',
    component: OperationDevisIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operationDevis/show/:operationDevisId',
    name: 'OperationDevisShow',
    component: OperationDevisShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operationDevis/edit/:operationDevisId',
    name: 'OperationDevisEdit',
    component: OperationDevisEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/facture/index/:operationId',
    name: 'OperationFactureIndex',
    component: OperationFactureIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/facture/show/:factureId?&:operationId?',
    name: 'OperationFactureShow',
    component: OperationFactureShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },

  {
    path: '/operation/facture/create/:factureId?&:operationId?',
    name: 'OperationFactureCreate',
    component: OperationFactureCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/facture/edit/:factureId?&:operationId?',
    name: 'OperationFactureEdit',
    component: OperationFactureCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/devisFactures/index/:operationId',
    name: 'OperationDevisFacturesIndex',
    component: OperationDevisFacturesIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/operation/devisFactures/show/:operationId/:devisId',
    name: 'OperationDevisFactureShow',
    component: OperationDevisFactureShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/venteLot/index',
    name: 'VenteLotIndex',
    component: VenteLotIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/venteLot/createEdit/:venteLotId?',
    name: 'VenteLotCreateEdit',
    component: VenteLotCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/venteLot/show/:venteLotId?',
    name: 'VenteLotShow',
    component: VenteLotShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/venteLot/showAgent/:venteLotId?',
    name: 'VenteLotShowAgent',
    component: VenteLotShowAgent,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_AGENT_IMMO']
    }
  },
  {
    path: '/tutorial/index',
    name: 'TutorialIndex',
    component: TutorialIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  },
  {
    path: '/tutorial/create',
    name: 'TutorialCreate',
    component: TutorialCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/tutorial/edit/:tutorialId',
    name: 'TutorialEdit',
    component: TutorialCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/tutorial/show/:tutorialId',
    name: 'TutorialShow',
    component: TutorialShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/tutorial/updateOrdre',
    name: 'TutorialUpdateOrdre',
    component: TutorialUpdateOrdre,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/partenaire/index',
    name: 'PartenaireIndex',
    component: PartenaireIndex,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    },
  },
  {
    path: '/partenaire/create',
    name: 'PartenaireCreate',
    component: PartenaireCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/partenaire/edit/:partenaireId',
    name: 'PartenaireEdit',
    component: PartenaireCreateEdit,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/partenaire/show/:partenaireId',
    name: 'PartenaireShow',
    component: PartenaireShow,
    meta: {
      requiresAuth: true,
      roles: ['ROLE_ADMIN', 'ROLE_ESTATE_AGENT', 'ROLE_COLLABORATOR', 'ROLE_COLLABORATOR_PLUS']
    }
  }
]

const router = new VueRouter({
  routes
})

// the meta: {requiresAuth: true} key. If a route has the meta key, it checks the store for a token; if present, it redirects them to the login route.
router.beforeEach((to, from, next) => {
  if (store.state.unsavedChangesStore.unsavedChanges && from.name !== null) {
    Vue.prototype.$globalConfirm("Vous avez des modifications non enregistrées. Voulez-vous quitter?")
      .then((confirmed) => {
        if (confirmed) {
          store.commit('setUnsavedChanges', false);
          proceedWithAuthCheck();
        } else {
          next(false);
        }
      })
      .catch(() => {
        next(false);
      });
  } else {
    proceedWithAuthCheck();
  }

  function proceedWithAuthCheck() {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!store.getters.isAuthenticated) {
        next('/login');
      } else {
        const hasRole = to.matched.some(record => record.meta.roles && store.getters.roles.some(role => record.meta.roles.includes(role)));
        if (hasRole) {
          fetchPendingStoreAndProceed();
        } else {
          store.commit('setUnsavedChanges', false);
          store.dispatch('LogOut').then(r => {
          })
          next('/login')

        }
      }
    } else if (to.matched.some(record => record.meta.guest) && store.getters.isAuthenticated) {
      next('/');
    } else {
      next();
    }
  }

  function fetchPendingStoreAndProceed() {
    Promise.all([
      store.dispatch('fetchPendingAnnouncementsCount'),
      store.dispatch('fetchPendingTasksCount'),
    ]).then(() => {
      next();
    }).catch(() => {
      next();
    });
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js